import { render, staticRenderFns } from "./EventTypeAdd.vue?vue&type=template&id=e0dea3e0&scoped=true"
import script from "./EventTypeAdd.vue?vue&type=script&lang=js"
export * from "./EventTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./EventTypeAdd.vue?vue&type=style&index=0&id=e0dea3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dea3e0",
  null
  
)

export default component.exports